
//城市排名前10
import React, { Component } from "react";
import moment from "moment";
import ScGridTable from "@/components/display/table/gridTableCore";
import PropTypes from "prop-types";
import monthPickerHoc from "@/hoc/form/monthPickerHoc";
import { cityRank } from "@/fetch/fetchApi";
import RefreshGrid from "../../utils/refreshGrid";

const defaultDate = moment();

@monthPickerHoc
class CityRankList extends Component {
  constructor(props) {
    super(props);
    this.props = props;
    this.state = {
      gridData: [],
      startTime:this.props.param.date,
      cityIds:this.props.param.cityIds,
      provinceIds:this.props.param.provinceIds,
    };

    
    this.layout = [
      "inline", // 横向布局
      "horizontal", // 纵向布局
    ];
    this.query = {
      month: defaultDate.format("YYYY-MM"),
      stubId: this.props.stubId,
      page: 1,
    };
  }

    static contextTypes = {
      store: PropTypes.object.isRequired,
    }

    
  // 父组件修改param时执行
  componentWillReceiveProps(nextProps) {
    if (
      nextProps.param.provinceIds === this.state.provinceIds
      && nextProps.param.cityIds === this.state.cityIds
      && nextProps.param.date === this.state.startTime
    ) {
    } else {
      this.setState(
        {
          cityIds: nextProps.param.cityIds,
          provinceIds: nextProps.param.provinceIds, // 默认 000000全国
          startTime: nextProps.param.date,
        },
        () => {
          // 获取数据
          console.log(111111111)
          console.log(this.state)
          var params = {
            isKanBan: "1",
            startTime:this.state.startTime,
            cityIds:this.state.cityIds,
            provinceIds:this.state.provinceIds,
          };
          RefreshGrid(this.context.store, "cityRankList", params);
        },

      );
      
    }
  }

    componentWillMount() {
      this.init();
    }

    init() {
      this.setState({
        tableConfig: {
          noPagination:{ position: ['top', 'None'] },
          tableColumns: [{
            name: "排名",
            key: "rankNum",
            colType: "textCol",
            align: "center",
          },
          {
            name: "城市",
            key: "cityName",
            colType: "textCol",
            align: "center",
          }, {
            name: "城市评分",
            key: "totalScore",
            colType: "textCol",
            align: "center",
          }],
          tableInfo: {
            hasRow: !1, // 是否显示checkbox
          },
          tableChange: () => {
            // grid翻页页，排序， 筛选过滤时触发
            console.debug("change");
          },
          autoRefresh: 1, // 设置为true 直接加载grid数据
          dataApi: cityRank,
          tableKey: "cityRankList",
          context: this,
          tableParam: {
            isKanBan: "1",
            startTime:this.state.startTime,
            cityIds:this.state.cityIds,
            provinceIds:this.state.provinceIds,

          },
        },
      });
    }

    fetchApi = (params) => {
      let result = {
        ...params,
      };
      if (params.month) {
        result = {
          ...result,
          month: params.month.format("YYYYMM"),
        };
      }
      return result;
    };

    render() {
      return (
        <div className="board-inner"
        style={{ height: "100%", display: "flex", flexDirection: "column", marginTop: "25px" }}>
          <div className="page-panel">
            <ScGridTable config={this.state.tableConfig} />
          </div>
        </div>
      );
    }
}

export default CityRankList;



// WEBPACK FOOTER //
// ./src/AntD/pages/displayBoard/cityRankList.js